module.exports = "/images/home.svg?ef508236cf08f64386c0476ee733e5ca";